module.exports = __webpack_public_path__ + "img/DE03946.9d12debc.png";